"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseView_1 = require("@/views/BaseView");
var vue_property_decorator_1 = require("vue-property-decorator");
var ViewWrapper_vue_1 = __importDefault(require("@/components/view-wrapper/ViewWrapper.vue"));
var parameters_1 = __importDefault(require("@/config/parameters"));
var Vendors = /** @class */ (function (_super) {
    __extends(Vendors, _super);
    function Vendors() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasSession = false;
        _this.partnership = null;
        return _this;
    }
    Vendors.prototype.mounted = function () {
        var _this = this;
        this.pdfUrl = parameters_1.default.cdn.host + "/pdf/vendors-sign-up-manual.pdf";
        this.$getPartnershipDataService.request(this.$route.params.partnershipSlug).then(function (response) { return _this.partnership = response; }, function (error) {
            _this.$router.push({ name: 'error', params: { code: error.response.status } });
        });
        this.hasSession = this.$oAuth2.getSessionId() !== null;
        this.$root.$on('AUTHENTICATED_EVENT', function () {
            _this.hasSession = true;
        });
    };
    Vendors.prototype.openLogin = function () {
        this.$scrollToTop();
        this.$root.$emit('ASK_USER_CREDENTIALS');
    };
    Vendors = __decorate([
        vue_property_decorator_1.Component({
            name: 'Vendors',
            components: {
                ViewWrapper: ViewWrapper_vue_1.default
            },
            metaInfo: function () {
                var title = this.$t("title." + this.$route.name);
                var metaInfo = {
                    title: this.$t('title.default'),
                    titleTemplate: '%s | ' + title,
                    meta: [
                        { name: 'og:title', content: title },
                        { name: 'og:url', content: window.location.href }
                    ],
                    link: [
                        { rel: 'canonical', href: window.location.href }
                    ]
                };
                return metaInfo;
            }
        })
    ], Vendors);
    return Vendors;
}(BaseView_1.BaseView));
exports.default = Vendors;
